var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ranking-query-index" },
    [
      _c("dzTab", {
        attrs: {
          active: _vm.activeTab,
          tabs: _vm.tabs,
          name: _vm.$options.name,
          "use-route": "",
        },
        on: {
          "update:active": function ($event) {
            _vm.activeTab = $event
          },
        },
      }),
      _vm._t("notice", null, { activeTab: _vm.activeTab }),
      _c(
        "router-view",
        _vm._b(
          { attrs: { checkVersion: _vm.checkVersion } },
          "router-view",
          _vm.$attrs,
          false
        )
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }